import { useIonRouter } from "@ionic/react";
import { Fragment, useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { IoIosPeople } from "react-icons/io";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import Badge from "../../ui-components/Badge";
import { CanadianButton } from "../../ui-components/CanadianButton";
import sidebarLinks from "../../utils/sidebarLinks";
import { AiIcon } from "../form/PostForm";
import { Footer } from "./Footer";

function SidebarLeft() {
  const { t } = useTranslation();
  const [fullScreenMenuOpen, setFullScreenMenuOpen] = useState(false);
  const location = useLocation();
  const router = useIonRouter();
  const { username, fname, lname, isAdmin, notifications } = useSelector(
    (state) => state.currentProfile.data,
  );
  const unreadAlertsCount = notifications?.filter((n) => !n.read).length || 0;
  const unread = useSelector((state) => state.chat.unread);

  const handleLoonAIClick = (e) => {
    e.preventDefault();
    setFullScreenMenuOpen(false);
    toast(
      t("comingSoonAI", { defaultValue: "Coming soon… Under Development" }),
      {
        duration: 3000,
        position: "top-center",
        style: {
          background: "#333",
          color: "#fff",
        },
      },
    );
  };

  // Filter sidebar links based on admin status
  const filteredLinks = sidebarLinks.filter(
    (link) => !link.adminOnly || isAdmin,
  );

  return (
    <aside className="sidebar-left display-flex justify-content-sb">
      {filteredLinks.map((link, linkIdx) => {
        const isActive =
          location.pathname.split("/")[1] === link.path.split("/")[1];
        const isExternal =
          link.path.startsWith("https://") || link.path.startsWith("http://");
        const ExternalLink = "a";
        const InternalLink = Link;

        const MyLink = isExternal ? ExternalLink : InternalLink;
        const linkProps = isExternal
          ? {
              href: link.path,
            }
          : {
              to: link.class === "profile" ? link.path + username : link.path,
            };

        const linkText = t(link.text); // translate link.text key

        const content =
          link.text === "LoonAI" ? (
            <MyLink
              className={`sidebar-left__link sidebar-left__link--${
                link.class
              } ${isActive ? "active" : ""}`}
              {...linkProps}
              onClick={handleLoonAIClick}
            >
              <AiIcon className="sidebar-left__icon" />
              <p className="sidebar-left__text">{linkText}</p>
            </MyLink>
          ) : link.text === "Post" ? (
            <div className="button-post-container">
              <CanadianButton
                onClick={() => {
                  router.push(
                    `/new-post${
                      location.pathname.startsWith("/hashtag/")
                        ? `?post=${encodeURIComponent(
                            `#${location.pathname.split("/hashtag/")[1]}`,
                          )}`
                        : ""
                    }`,
                  );
                  setFullScreenMenuOpen(false);
                }}
              >
                {linkText}
              </CanadianButton>
            </div>
          ) : (
            <Fragment>
              <MyLink
                className={`sidebar-left__link sidebar-left__link--${
                  link.class
                } ${isActive ? "active" : ""}`}
                {...linkProps}
                onClick={() => setFullScreenMenuOpen(false)}
              >
                {isActive && !!link.filledIcon ? (
                  <link.filledIcon className="sidebar-left__icon" />
                ) : !!link.icon ? (
                  <link.icon className="sidebar-left__icon" />
                ) : null}

                <p className="sidebar-left__text">{linkText}</p>
              </MyLink>
              {/* {linkIdx === 0 && (
                <Link
                  className={`sidebar-left__link sidebar-left__link--trending ${location.pathname.slice("/")[1] === "trending"
                      ? "active"
                      : ""
                    }`}
                  to="/trending"
                  onClick={() => setFullScreenMenuOpen(false)}
                >
                  <IoIosPeople className="sidebar-left__icon" />
                  <p className="sidebar-left__text">{t("Trending")}</p>
                </Link>
              )} */}
            </Fragment>
          );

        return (
          <div key={link.text}>
            {link.text === "Messages" || link.text === "Alerts" ? (
              <MyLink
                className={`sidebar-left__link sidebar-left__link--${
                  link.class
                } ${isActive ? "active" : ""}`}
                {...linkProps}
                onClick={() => setFullScreenMenuOpen(false)}
              >
                <Badge
                  content={
                    link.text === "Messages" ? unread.total : unreadAlertsCount
                  }
                >
                  {isActive && !!link.filledIcon ? (
                    <link.filledIcon className="sidebar-left__icon" />
                  ) : !!link.icon ? (
                    <link.icon className="sidebar-left__icon" />
                  ) : null}
                </Badge>
                <p className="sidebar-left__text">{linkText}</p>
              </MyLink>
            ) : (
              content
            )}
          </div>
        );
      })}

      <div className="show-on-desktop">
        <Footer />
      </div>
    </aside>
  );
}

export default SidebarLeft;
